import AbstractPage from './AbstractPage';
import { timeout } from 'frontools/decorators/Timeout';
import { Overlay, OverlayOptions } from '../modules/Overlay';
import Template from 'frontools/data/Template';
import { Video } from "./Video";
import SwiperManager from '../modules/SwipersManager';
import OverlaysManager from '../modules/OverlaysManager';
import ImageSizeManager from '../modules/ImageSizeManager';
import Context from 'frontools/core/Context';

declare var Masonry;

export class Projet extends AbstractPage {
    private _elVideoPosters  : NodeListOf<HTMLElement>;

    private _videos          : Array<Video>         = [];
    private _masonryGrids    : Array<any>           = [];
    
    private _swipersManager  : SwiperManager;   
    private _overlaysManager  : OverlaysManager;
    private _imageSizeManager : ImageSizeManager;

    protected _lastBreakpointSize : {height: number, width: number} = {height: 0, width: 0};

    constructor() {
        super();
        this._overlaysManager = new OverlaysManager(); 
        this._createMasonryGrids();
        this._createVideos();
        this._swipersManager = new SwiperManager(); 
        this._imageSizeManager = new ImageSizeManager();
        this._removeHashFromUrl();
    }

    private _removeHashFromUrl() {
        const categoryParam = Context.getInstance().getURL().query.cat;
        const projectParam = Context.getInstance().getURL().query.proj;
        if (categoryParam || projectParam) {
            let urlWithoutHash = window.location.href.split('?')[0];
            window.history.replaceState(urlWithoutHash, urlWithoutHash, urlWithoutHash);
        }
    }

    private _createVideos() {
        this._elVideoPosters = document.querySelectorAll('[data-js-vimeo]') as NodeListOf<HTMLElement>;
        for (let i = 0; i < this._elVideoPosters.length; i++) {  
            this._elVideoPosters[i].querySelector('.video_poster').addEventListener('click', function(e) {  
                let elParent = this._elVideoPosters[i];
                let idVideo : string = elParent.getAttribute('data-js-vimeo');
                let elPoster = elParent.querySelector('.video_poster') as HTMLElement;
                let video = new Video(idVideo, elParent, elPoster);
                this._videos.push();
            }.bind(this));
        }
    }

    @timeout(1000)
    private _createMasonryGrids() {
        var wrappers = document.querySelectorAll('.m_gallery_grid') as NodeListOf<HTMLElement>;
        for (var index = 0; index < wrappers.length; index++) {
            var element = wrappers[index];
            var grid =  wrappers[index].querySelector('.g_float') as HTMLElement;
            if (grid) {
                var masonry = new Masonry( grid, {
                    itemSelector: '.g_item',
                    horizontalOrder: true   
                }); 
                this._masonryGrids.push(masonry);
            }
        }
    }

    protected onResize() {
        // Hack for no resize in ios when nav bar is hidden/shown
        if ( Math.abs(this._lastBreakpointSize.width-window.innerWidth) > 0 || Math.abs(this._lastBreakpointSize.height - window.innerHeight) >= 100) {
            this._lastBreakpointSize.width = window.innerWidth;
            this._lastBreakpointSize.height = window.innerHeight;
    
            if (this._swipersManager) this._swipersManager.onResize();    
            if (this._imageSizeManager) this._imageSizeManager.onResize();
            if (this._overlaysManager) this._overlaysManager.onResize();
        } 
    }

    protected onResizeMobile() {
        super.onResizeMobile();
        if (!this._swipersManager.mobileSwipers.length) this._swipersManager.createSwipersMobile();
    }

    protected onResizeDesktop() { 
        super.onResizeDesktop();
        if (this._swipersManager.mobileSwipers.length) this._swipersManager.destroySwipersMobile();
        this._swipersManager.destroySwipersDesktop();
        this._swipersManager.createSwipers();
    } 
    
}